import { render, staticRenderFns } from "./ReportCancellation.vue?vue&type=template&id=2ef46264&scoped=true&"
import script from "./ReportCancellation.vue?vue&type=script&lang=js&"
export * from "./ReportCancellation.vue?vue&type=script&lang=js&"
import style0 from "./ReportCancellation.vue?vue&type=style&index=0&id=2ef46264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef46264",
  null
  
)

export default component.exports